@if (skalVises()) {
  <div class="kontainer" [class]="stil()" @fadeInn [@.disabled]="!forsinketVisning()">
    <i class="lederplan-ikon-graduate-cap"></i>
    <div class="innhold-kontainer">
      <div class="innhold" data-testid="tips-innhold">
        <ng-content/>
      </div>
      @if (stil() == 'stor' && !skjulTipshandling()) {
        <div class="handlinger">
          <a href="{{tipslenke}}" target="_blank">{{ 'Få flere tips til effektive møter her.'|translate }}</a>
          <a (click)="skjul()">{{ 'Skjønner - ikke vis tipset igjen.'|translate }}</a>
        </div>
      }
    </div>
  </div>
}
